import React from "react";
import ReactModal, { Styles } from "react-modal";

ReactModal.setAppElement("#__next");

interface Props {
  bgColor?: string;
  children?: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const Modal = ({ bgColor, children, isOpen, onClose }: Props) => {
  return (
    // @ts-ignore
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      style={
        bgColor
          ? {
              ...modalStyle,
              content: { ...modalStyle.content, background: bgColor },
            }
          : modalStyle
      }
    >
      {children}
    </ReactModal>
  );
};

const modalStyle: Styles = {
  content: {
    background: "var(--body-bg-clr)",
    border: "none",
    borderRadius: 12,
    bottom: "unset",
    left: "50%",
    maxWidth: 688,
    right: "unset",
    top: "50%",
    transform: "translateX(-50%) translateY(-50%)",
    width: "95%",
  },
  overlay: {
    background: "#0003",
    zIndex: 20,
  },
};

export default Modal;
